import React, { useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import LogoUpload from "../common/LogoUpload";
import FormSelect from "../common/FormSelect";

import * as yup from "yup";
import FormInput from "../common/FormInput";

  const schema = yup.object().shape({
    agencyLogo: yup
  .mixed()
  .test("required", "Agency Logo is required", (value) => value && value.length > 0)
  .test("fileSize", "File size should not exceed 4MB", (value) => {
    return value && value[0] && value[0].size <= 4 * 1024 * 1024;
  }),
    agencyName: yup.string().required("Agency Name is required"),
    taxId: yup.string().required("Tax ID is required"),
    npi: yup.string().required("NPI is required"),
    licenseNumber: yup.string().required("License Number is required"),
    licenseExpirationDate: yup.date().required("License Expiration Date is required"),
    agencyType: yup.string().required("Agency Type is required"),
  });


  const formFields = [
    { label: "Agency Name", name: "agencyName", type: "text", component: "input" },
    { label: "Tax ID", name: "taxId", type: "text", component: "input" },
    { label: "NPI", name: "npi", type: "text", component: "input" },
    { label: "License Number", name: "licenseNumber", type: "text", component: "input" },
    { label: "License Expiration Date", name: "licenseExpirationDate", type: "date", component: "input" },
    { label: "Agency Type", name: "agencyType", component: "select", options: [
        { value: "Independent", label: "Independent" },
        { value: "Organization", label: "Organization" },
        { value: "Hospital", label: "Hospital" },
      ]
    },
  ];

  const servicesList = [
    { label: "Speech Therapy", name: "speechTherapy" },
    { label: "Occupational Therapy", name: "occupationalTherapy" },
    { label: "Physical Therapy", name: "physicalTherapy" },
    { label: "Special Instruction", name: "specialInstruction" },
    { label: "Assistive Technology", name: "assistiveTechnology" },
  ];

  const InsuaranceField=[
    {label:"Insurance Provider Name", name:"InsuranceProviderName", type:"text", component:"input"},
    {label:"Insurance Policy Number", name:"InsurancePolicyNumber", type:"text", component:"input"},
    {label:"Policy Effective Date", name:"PolicyEffectiveDate", type:"date", component:"input"},
    {label:"Policy Expiration Date", name:"PolicyExpirationDate", type:"date", component:"input"}
  ]

  const Certifications=[
    {label:"Certification Name", name:"CertificationName", type:"text", component:"input"},
    {label:"Issuing Organization", name:"InsurancePolicyNumber", type:"text", component:"input"},
    {label:"Policy Effective Date", name:"PolicyEffectiveDate", type:"date", component:"input"},
    {label:"Policy Expiration Date", name:"PolicyExpirationDate", type:"date", component:"input"}
  ]
  
  

const ProviderRegistrationForm = () => {
  const {
    register,
    control, // ✅ Add this to fix the error
    handleSubmit,
    trigger, 
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { 
      staffMembers: [{}],
      services: {},
      insurance: {},
      certifications: {},
    },
  });
  



  const { fields, append, remove } = useFieldArray({
    control,
    name: "staffMembers",
  });


  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="advance-search">
        <div className="search-header">
          <div className="title">
            <button className="" >
            Agency Information
            </button>
          </div>
        </div>

        <div className="search-body">
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <LogoUpload register={register} setValue={setValue} trigger={trigger} errors={errors} />
                </div>
              </div>
            </div>

            <div className="col-xl-9 col-lg-9 col-md-9 col-12">
              <div className="row">
                {formFields.map((field, index) => (
                  <div key={index} className="col-xl-4 col-lg-4 col-md-4 col-12">
                    {field.component === "input" ? (
                      <FormInput label={field.label} name={field.name} type={field.type} register={register} errors={errors} />
                    ) : (
                      <FormSelect label={field.label} name={field.name} options={field.options} register={register} errors={errors} />
                    )}
                  </div>
                ))}
              </div>
            </div>

            <hr style={{color:"blue", padding:"2px"}}/>
            <h6><strong>Available Services</strong></h6>


            {servicesList.map((service, index) => (
              <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-12">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    {...register(`services.${service.name}`)}
                  />
                  <label className="form-check-label">{service.label}</label>
                </div>
              </div>
            ))}

            {/* Other (Text Field) */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Other (Specify)</label>
                <input className="form-control" {...register("services.other")} />
              </div>
            </div>

            <hr style={{color:"blue", padding:"2px"}}/>
            <h6><strong>Insurance & Payment Information</strong></h6>

            {InsuaranceField.map((field, index)=>{
                  return(
                    <div key={index} className="col-xl-3 col-lg-3 col-md-3 col-12">
                    <FormInput label={field.label} name={field.name} type={field.type} register={register} errors={errors}/>
                  </div>
                  )
            })}



            {/* Coverage Details */}
            <div className="col-12">
              <div className="form-group">
                <label className="form-label">Coverage Details</label>
                <textarea className="form-control" rows="1" {...register("insurance.coverageDetails")}></textarea>
                <p className="text-danger">{errors.insurance?.coverageDetails?.message}</p>
              </div>
            </div>

            <hr style={{color:"blue", padding:"2px"}}/>
            <h6><strong>Certifications & Accreditation</strong></h6>
                


            {/* Certification Name */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Certification Name</label>
                <input className="form-control" {...register("certifications.name")} />
                <p className="text-danger">{errors.certifications?.name?.message}</p>
              </div>
            </div>

            {/* Issuing Organization */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Issuing Organization</label>
                <input className="form-control" {...register("certifications.organization")} />
                <p className="text-danger">{errors.certifications?.organization?.message}</p>
              </div>
            </div>

            {/* Issue Date */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Issue Date</label>
                <input type="date" className="form-control" {...register("certifications.issueDate")} />
                <p className="text-danger">{errors.certifications?.issueDate?.message}</p>
              </div>
            </div>

            {/* Expiration Date */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Expiration Date</label>
                <input type="date" className="form-control" {...register("certifications.expirationDate")} />
                <p className="text-danger">{errors.certifications?.expirationDate?.message}</p>
              </div>
            </div>

            {/* Status */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Status</label>
                <select className="form-select" {...register("certifications.status")}>
                  <option value="">Select Status</option>
                  <option value="Valid">Valid</option>
                  <option value="Expired">Expired</option>
                  <option value="Pending Renewal">Pending Renewal</option>
                </select>
                <p className="text-danger">{errors.certifications?.status?.message}</p>
              </div>
            </div>

          </div>
        </div>

      </div>

      <div className="advance-search">
        <div className="search-header">
          <div className="title">
            <button className="collapsed" >
            Contact Details
            </button>
          </div>
          <div className="search-button">
            <div className="search-icon  collapsed"  type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
            </div>
          </div>
        </div>

        <div id="flush-collapseOne" className="search-body accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Contact Person Name</label>
                <input className="form-control" {...register("taxId")} />
                <p className="text-danger">{errors.taxId?.message}</p>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Designation</label>
                <select className="form-select" {...register("agencyType")}>
                  <option value="">Select Agency Type</option>
                  <option value="Independent">Director</option>
                  <option value="Organization">Coordinator</option>
                  <option value="Hospital">Administrator</option>
                </select>
                <p className="text-danger">{errors.agencyType?.message}</p>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input className="form-control" {...register("npi")} />
                <p className="text-danger">{errors.npi?.message}</p>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Email </label>
                <input className="form-control" {...register("npi")} />
                <p className="text-danger">{errors.npi?.message}</p>
              </div>
            </div>


          </div>
        </div>

      </div>

      <div className="advance-search">
        <div className="search-header">
          <div className="title">
            <button className="collapsed">Office Location</button>
          </div>
          <div className="search-button">
            <div
              className="search-icon collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
              aria-expanded="false"
              aria-controls="flush-collapseTwo"
            ></div>
          </div>
        </div>

        <div id="flush-collapseTwo" className="search-body accordion-collapse collapse">
          <div className="row">
            {/* Location Name */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Location Name</label>
                <input className="form-control" {...register("locationName")} />
                <p className="text-danger">{errors.locationName?.message}</p>
              </div>
            </div>

            {/* Address Line 1 */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Address Line 1</label>
                <input className="form-control" {...register("address1")} />
                <p className="text-danger">{errors.address1?.message}</p>
              </div>
            </div>

            {/* Address Line 2 (Optional) */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Address Line 2 (Optional)</label>
                <input className="form-control" {...register("address2")} />
              </div>
            </div>

            {/* City */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">City</label>
                <input className="form-control" {...register("city")} />
                <p className="text-danger">{errors.city?.message}</p>
              </div>
            </div>

            {/* State Dropdown */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">State</label>
                <select className="form-select" {...register("state")}>
                  <option value="">Select State</option>
                  <option value="NY">New York</option>
                  <option value="CA">California</option>
                  <option value="TX">Texas</option>
                  <option value="FL">Florida</option>
                  {/* Add more states as needed */}
                </select>
                <p className="text-danger">{errors.state?.message}</p>
              </div>
            </div>

            {/* Zip Code */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Zip Code</label>
                <input className="form-control" {...register("zipCode")} />
                <p className="text-danger">{errors.zipCode?.message}</p>
              </div>
            </div>

            {/* Phone Number */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input className="form-control" {...register("phone")} />
                <p className="text-danger">{errors.phone?.message}</p>
              </div>
            </div>

            {/* Fax Number (Optional) */}
            <div className="col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="form-group">
                <label className="form-label">Fax Number (Optional)</label>
                <input className="form-control" {...register("faxNumber")} />
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="advance-search">
        <div className="search-header">
          <div className="title">
            <button className="collapsed">
              Staff Members
            </button>
          </div>

          <div className="search-button">
            <div
              className="search-icon collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#staffCollapse"
              aria-expanded="false"
              aria-controls="flush-collapseCertifications"
            ></div>
          </div>
        </div>

        <div id="staffCollapse" className="search-body accordion-collapse collapse">
          {fields.map((staff, index) => (
            <div key={staff.id} className="row">
              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input className="form-control" {...register(`staffMembers.${index}.fullName`)} />
                  <p className="text-danger">{errors.staffMembers?.[index]?.fullName?.message}</p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <div className="form-group">
                  <label className="form-label">Role</label>
                  <select className="form-select" {...register(`staffMembers.${index}.role`)}>
                    <option value="">Select Role</option>
                    <option value="Therapist">Therapist</option>
                    <option value="Administrator">Administrator</option>
                    <option value="Support Staff">Support Staff</option>
                  </select>
                  <p className="text-danger">{errors.staffMembers?.[index]?.role?.message}</p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <div className="form-group">
                  <label className="form-label">NPI (Optional)</label>
                  <input className="form-control" {...register(`staffMembers.${index}.npi`)} />
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <div className="form-group">
                  <label className="form-label">Professional License Number</label>
                  <input className="form-control" {...register(`staffMembers.${index}.licenseNumber`)} />
                  <p className="text-danger">{errors.staffMembers?.[index]?.licenseNumber?.message}</p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <div className="form-group">
                  <label className="form-label">License Expiration Date</label>
                  <input type="date" className="form-control" {...register(`staffMembers.${index}.licenseExpirationDate`)} />
                  <p className="text-danger">{errors.staffMembers?.[index]?.licenseExpirationDate?.message}</p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <input className="form-control" {...register(`staffMembers.${index}.phone`)} />
                  <p className="text-danger">{errors.staffMembers?.[index]?.phone?.message}</p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input className="form-control" type="email" {...register(`staffMembers.${index}.email`)} />
                  <p className="text-danger">{errors.staffMembers?.[index]?.email?.message}</p>
                </div>
              </div>

             

              <div className="col-12 text-end mt-2">
                {fields.length > 1 && (
                  <button type="button" className="btn btn-danger" onClick={() => remove(index)}>Remove</button>
                )}
              </div>
            </div>
          ))}

          <div className="col-12">
            <button type="button" className="btn btn-primary mb-2" onClick={() => append({})}>+ Add Staff</button>
          </div>
        </div>
      </div>

      <div className="advance-search">
        <div className="search-header">
          <div className="title">
            <button className="collapsed">
              Compliance & Audits
            </button>
          </div>

          <div className="search-button">
            <div
              className="search-icon collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#complianceAuditSection"
              aria-expanded="false"
              aria-controls="flush-collapseCertifications"
            ></div>
          </div>
        </div>

        <div id="complianceAuditSection" className="search-body accordion-collapse collapse">
          <div className="row">
            {/* Last Audit Date */}
            <div className="col-xl-4 col-lg-4 col-md-4 col-12">
              <div className="form-group">
                <label className="form-label">Last Audit Date</label>
                <input type="date" className="form-control" {...register("lastAuditDate")} />
                <p className="text-danger">{errors.lastAuditDate?.message}</p>
              </div>
            </div>

            {/* Audit Result */}
            <div className="col-xl-4 col-lg-4 col-md-4 col-12">
              <div className="form-group">
                <label className="form-label">Audit Result</label>
                <select className="form-select" {...register("auditResult")}>
                  <option value="">Select Audit Result</option>
                  <option value="Pass">Pass</option>
                  <option value="Fail">Fail</option>
                  <option value="Pending">Pending</option>
                </select>
                <p className="text-danger">{errors.auditResult?.message}</p>
              </div>
            </div>

            {/* Notes */}
            <div className="col-xl-4 col-lg-4 col-md-4 col-12">
              <div className="form-group">
                <label className="form-label">Notes</label>
                <textarea className="form-control" rows="1" {...register("notes")}></textarea>
                <p className="text-danger">{errors.notes?.message}</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="d-flex justify-content-center">
        <button type="submit" className="button save me-2"><i className="bi bi-send"></i> Submit</button>
        <button type="submit" className="button info me-2"><i className="bi bi-save"></i> Save as Draft</button>
        <button type="submit" className="button cancel"><i className="bi bi-x-lg"></i> Reset </button>
      </div>

    </form>
  );
};

export default ProviderRegistrationForm;
